/* @flow */

import { makeListLink } from './utils';

export default makeListLink({ pathname: '/ohmr', children: 'ohmr' });



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/components/Links/OHMRLink.js